var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      ref: "chart",
      class: "js_export_report_dymanic_chart",
      style: _vm.showStub ? { pointerEvents: "none" } : null,
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "legend",
        class: [_vm.$.legend, "export_html_legend"],
        style: { width: _vm.width, left: _vm.leftPos },
      },
      _vm._l(_vm.legendItems, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            class: [
              _vm.$.wrapper,
              "export_html_legend_item",
              _vm.disabledSeries[item.name] && "disabled",
            ],
            on: {
              click: function ($event) {
                return _vm.toggleSelect(item.name)
              },
            },
          },
          [
            _c("div", {
              class: [_vm.$.icon, "export_html_icon"],
              style: { color: item.color },
              domProps: { innerHTML: _vm._s(_vm.svgLegendItem) },
            }),
            _vm._v(" "),
            _c("div", { class: [_vm.$.name, "export_html_name"] }, [
              _vm._v("\n        " + _vm._s(item.label) + "\n      "),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.showStub && _vm.showStubMessage
      ? _c(
          "div",
          {
            class: _vm.$.stub_description,
            style: { width: _vm.width, left: _vm.leftPos },
          },
          [
            _c("div", { class: _vm.$.wrapper }, [
              _c("span", { class: _vm.$.text }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.locales("report_page_no_filtered_data")) +
                    "\n      "
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }